import { render, staticRenderFns } from "./IconArrowCircularFilledV3.vue?vue&type=template&id=4af2a325&scoped=true"
import script from "./IconArrowCircularFilledV3.vue?vue&type=script&lang=js"
export * from "./IconArrowCircularFilledV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2a325",
  null
  
)

export default component.exports